document.addEventListener('DOMContentLoaded', () => {

  const TextRoller = (() => {

    function getWidth(element) {
      const rect = element.getBoundingClientRect();
      return rect.right - rect.left;
    }

    function TextRoller(box, speed = 20) {
      this.box = box;
      this.speed = speed;
      this.original_element = box.children[0].cloneNode(true);
      this.original_element.style.position = "relative";

      this.position = 0;
      this._running = false;

      this.initStructure();
    }

    TextRoller.prototype.initStructure = function () {
      this.box.innerHTML = '';
      this.box.appendChild(this.original_element.cloneNode(true));
      this.inner_element = this.box.children[0];
      this.inner_element.style.position = "relative";

      this.box_width = getWidth(this.box);
      this.inner_element_width = getWidth(this.inner_element);
    };

    TextRoller.prototype.setUpChildren = function () {
      const needed = Math.ceil(this.box_width / this.inner_element_width) + 1;
      const current = this.box.children.length;
      const clone = this.original_element.cloneNode(true);

      for (let i = current; i < needed; i++) {
        const newNode = clone.cloneNode(true);
        newNode.style.position = "relative";
        this.box.appendChild(newNode);
      }

      for (let i = this.box.children.length - 1; i >= needed; i--) {
        this.box.removeChild(this.box.children[i]);
      }
    };

    TextRoller.prototype.updatePositions = function () {
      Array.from(this.box.children).forEach(child => {
        child.style.left = -this.position + 'px';
      });
    };

    TextRoller.prototype.nextFrame = function (delta) {
      this.box_width = getWidth(this.box);
      this.inner_element_width = getWidth(this.box.children[0]);
      this.setUpChildren();
      this.updatePositions();

      this.position += this.speed * delta / 1000;
      if (this.position >= this.inner_element_width) {
        this.position %= this.inner_element_width;
      }
    };

    TextRoller.prototype.start = function () {
      if (this._running) return;

      this._running = true;
      let lastTime = null;

      const loop = () => {
        if (!this._running) return;

        const now = Date.now();
        const delta = lastTime === null ? 0 : now - lastTime;
        lastTime = now;

        this.nextFrame(delta);
        requestAnimationFrame(loop);
      };

      requestAnimationFrame(loop);
    };

    TextRoller.prototype.stop = function () {
      this._running = false;
    };

    TextRoller.prototype.reset = function () {
      this.stop();
      this.position = 0;
      this.box.innerHTML = '';
      const clone = this.original_element.cloneNode(true);
      clone.style.position = "relative";
      clone.style.left = "0px";
      this.box.appendChild(clone);
    };

    return TextRoller;

  })();

  const rollers = [];

  function handleResponsiveRollers() {
    document.querySelectorAll('.js-text-roller').forEach((el, index) => {
      const media = parseInt(el.dataset.media, 10);
      const shouldActivate = isNaN(media) || window.innerWidth < media;

      if (!rollers[index]) {
        rollers[index] = {
          el: el,
          instance: null,
          active: false
        };
      }

      const roller = rollers[index];

      if (shouldActivate && !roller.active) {
        roller.instance = new TextRoller(el, el.dataset.speed);
        roller.instance.start();
        roller.active = true;

      } else if (!shouldActivate && roller.active) {
        if (roller.instance) roller.instance.reset();
        roller.instance = null;
        roller.active = false;
      }
    });
  }

  window.addEventListener('resize', handleResponsiveRollers);
  handleResponsiveRollers();

}, false);
